var React = require('react');

function CheckGreenLight (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","r":"10","fill":"#DEF7EA","key":0}),React.createElement("path",{"d":"M13.9394 7.5L8.9394 12.5L6.66667 10.2273","stroke":"#1FAD64","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckGreenLight.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CheckGreenLight;

CheckGreenLight.default = CheckGreenLight;
